import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getAuth } from 'firebase/auth';
import { getStorage } from "firebase/storage";

const firebaseConfig = {

  apiKey: "AIzaSyDLLEroXsloXqY60uyBMGLDSP-slz39Q30",

  authDomain: "chex-ray.firebaseapp.com",

  projectId: "chex-ray",

  storageBucket: "chex-ray.appspot.com",

  messagingSenderId: "896214877818",

  appId: "1:896214877818:web:7d0a093f5738548cd4ddc3"

};

const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getDatabase(app);
const imgDb =getStorage(app);

export { db, auth , imgDb };